import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  salesOrderStatusCreate,
  salesOrderStatusCreateSuccess,
  salesOrderStatusDelete,
  salesOrderStatusDeleteSuccess,
  salesOrderStatusList,
  salesOrderStatusUpdate,
} from "../../../../store/salesOrder/action";
export default function SalesOrderSettings() {
  const dispatch = useDispatch();

  const { salesOrderStatusListAPI } = useSelector((state) => ({
    salesOrderStatusListAPI:
      state.SalesOrder.salesOrderStatusList?.salesorderstatus_list,
  }));

  const [paymentTerm, setPaymentTerm] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    LogicValue: "", //Duration
    LogicType: "", // Drop Down a type
  });

  const logicType = [
    {
      label: "Days",
      value: "1",
    },
    {
      label: "Months",
      value: "2",
    },
    {
      label: "Day of Next month",
      value: "3",
    },
    {
      label: "Last Day of the month",
      value: "4",
    },
    {
      label: "Last Working Day of the month",
      value: "5",
    },
  ];
  const [noColourChoiceRequired, setNoColourChoiceRequired] = useState(false);

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(salesOrderStatusCreate([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = salesOrderStatusListAPI?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(false);
      setPaymentTerm(false);
    }
    setStatusList(data);
  }, [salesOrderStatusListAPI, activeTab]);

  useEffect(() => {
    dispatch(salesOrderStatusList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete
      dispatch(salesOrderStatusDelete([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      LogicValue: updateItemStatus?.LogicValue,
      LogicType: updateItemStatus?.LogicType,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update
        dispatch(salesOrderStatusUpdate([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // success Add Update Delete
  const {
    salesOrderStatusCreateAPI,
    salesOrderStatusUpdateAPI,
    salesOrderStatusDeleteAPI,
  } = useSelector((state) => ({
    salesOrderStatusCreateAPI: state.SalesOrder.salesOrderStatusCreate,
    salesOrderStatusUpdateAPI: state.SalesOrder.salesOrderStatusUpdate,
    salesOrderStatusDeleteAPI: state.SalesOrder.salesOrderStatusDelete,
  }));

  // Add  Success Sales Order Status
  useEffect(() => {
    if (isEmpty(salesOrderStatusCreateAPI)) return;
    if (salesOrderStatusCreateAPI?.status === 200) {
      toast.success(salesOrderStatusCreateAPI?.message);
      dispatch(salesOrderStatusList());
    } else {
      toast.error(salesOrderStatusCreateAPI?.message);
    }
    dispatch(salesOrderStatusCreateSuccess([]));
  }, [salesOrderStatusCreateAPI]);

  // Delete Success Sales Order Status
  useEffect(() => {
    if (isEmpty(salesOrderStatusDeleteAPI)) return;
    if (salesOrderStatusDeleteAPI?.status === 200) {
      toast.success(salesOrderStatusDeleteAPI?.message);
      dispatch(salesOrderStatusList());
      setDeleteModal(false);
    } else {
      toast.error(salesOrderStatusDeleteAPI?.message);
    }
    dispatch(salesOrderStatusDeleteSuccess([]));
  }, [salesOrderStatusDeleteAPI]);

  // Update Success Sales Order Status
  useEffect(() => {
    if (isEmpty(salesOrderStatusUpdateAPI)) return;
    if (salesOrderStatusUpdateAPI?.status === 200) {
      toast.success(salesOrderStatusUpdateAPI?.message);
      dispatch(salesOrderStatusList());
    } else {
      toast.error(salesOrderStatusUpdateAPI?.message);
    }
    dispatch(salesOrderStatusUpdate([]));
  }, [salesOrderStatusUpdateAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Sales Order Settings"
        description="Statuses for sales orders."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          noColourChoiceRequired={noColourChoiceRequired}
          logicType={logicType}
          paymentTerm={paymentTerm}
        />
      </SettingsPanel>
    </>
  );
}
